const UIFilterWelcomerKind = ['instagram_welcomer', 'icebreakers'] as const;

type UIFilterWelcomerKindTuple = typeof UIFilterWelcomerKind;
export type UIFilterWelcomerKindType = UIFilterWelcomerKindTuple[number];

export function isWelcomerKind(s: any): s is UIFilterWelcomerKindType {
  return UIFilterWelcomerKind.includes(s);
}

export const welcomerTypeByKind: Record<
  UIFilterWelcomerKindType,
  { name: string }
> = {
  instagram_welcomer: {
    name: 'Edit Welcome Dialogue',
  },
  icebreakers: {
    name: 'Edit Icebreakers',
  },
};
